import { render, staticRenderFns } from "./CostBearersPaymentDocumentsFilter.vue?vue&type=template&id=da218556&scoped=true&"
import script from "./CostBearersPaymentDocumentsFilter.vue?vue&type=script&lang=ts&"
export * from "./CostBearersPaymentDocumentsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da218556",
  null
  
)

export default component.exports